export const payloadPaymentRollTransform = ({ state, ...args }) => {
    const jwt = args.jwt || state.jwt

    const {
        transactionToken,
        saleType,
        taxPlan,
        vehicleCondition,
        odometer,
        purchaseMethod,
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        term,
        cashDown,
        tradeIn,
        lien,
    } = state.paymentOptions || {}

    return {
        quoteId: state.quoteId,
        orgId: state.dealerInfos.orgId,
        orgUnitId: state.dealerInfos.orgUnitId,
        location: state.dealerInfos.location,
        lang: state.dealerInfos.lang,
        token: jwt,
        payload: {
            calculationTargetType: 'cashDown',
            calculationTargetValue: args.payment,
            includeTaxes: false,
            transactionToken,
            saleType,
            taxPlan,
            vehicleCondition,
            odometer,
            purchaseMethod,
            financePlan,
            kmPerYearPlan,
            paymentFrequency,
            term,
            cashDown,
            tradeIn,
            lien,
        },
    }
}
